import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { WorkerPool } from "types/generated";
import useCanDeleteWorkerPool from "shared/WorkerPool/access/useCanDeleteWorkerPool";

type WorkerPoolDeleteActionProps = {
  onAction: () => void;
  workerPool: WorkerPool;
};

const hasUsersTooltip = (
  <>
    Before you delete the worker pool, you must make sure it is not used by any stacks or modules.
  </>
);

const hasBusyWorkersTooltip = (
  <>
    Please drain all workers first to make sure that no work is being performed by this worker pool.
  </>
);

const WorkerPoolDeleteAction = ({
  onAction,
  workerPool,
}: WorkerPoolDeleteActionProps) => {
  const canDeleteWorkerPool = useCanDeleteWorkerPool();
  const accessResult = canDeleteWorkerPool(workerPool);
  const hasUsers = workerPool.usersCount > 0;
  const hasBusyWorkers = workerPool.busyWorkers > 0;

  const getTooltip = () => {
    if (!accessResult.result) {
      return accessResult.message;
    }
    if (hasBusyWorkers) {
      return hasBusyWorkersTooltip;
    }
    if (hasUsers) {
      return hasUsersTooltip;
    }
    return null;
  };

  const isDisabled = !accessResult.result || hasBusyWorkers || hasUsers;
  const tooltip = getTooltip();

  return (
    <DropdownMenuItem
      tooltip={tooltip}
      isTooltipActive={!!tooltip}
      tooltipWidthMode="maxWidthSm"
      tooltipPlacement="left"
      onAction={onAction}
      danger
      isDisabled={isDisabled}
    >
      Delete
    </DropdownMenuItem>
  );
};

export default WorkerPoolDeleteAction;
